export default __webpack_public_path__ + "static/CommonWealth-3c03eda8a83dd21c120ae6d889e92fae.png";